import { useSimpleQuery } from "common/graphql/useSimpleQuery";
import gql from "graphql-tag";
import React from "react";
import { GetStudyProgrammesData } from "__generated__/types";
import { ContentPage } from "domain/admin/common/ContentPage";
import { urls } from "common/urls";
import { Box } from "common/components/Box";

const GET_STUDY_PROGRAMMES = gql`
  query GetStudyProgrammesData {
    studyProgrammeList {
      id
      status
      title
    }
  }
`;

export const LibraryPage: React.FC = () => {
  const { data, loadingOrError } =
    useSimpleQuery<GetStudyProgrammesData>(GET_STUDY_PROGRAMMES);

  return (
    <ContentPage
      data={data?.studyProgrammeList}
      loadingOrError={loadingOrError}
      title="Biblioteket"
      breadcrumbs={[]} // TODO: Fix breadcrumbs
      elementUrl={(id: string) => urls.studyProgramme(id)}
      noDataText="Oisann – det finnes ingen studieprogram enda!"
    >
      <Box kind="information" rounded={false} centeredContent={false}>
        <b>Velkommen til biblioteket!</b> <br /> Her kan du bla rundt i alt
        innhold som er eller har vært pensum for ulike eksamener i ulike
        studieprogram – ikke bare dine egne eksamener. Husk å gå til ditt eget
        pensum for å få progresjon!
      </Box>
    </ContentPage>
  );
};
